import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Paper from '@material-ui/core/Paper'
import SvgIcon from '@material-ui/core/SvgIcon'
import moment from 'moment'
import { resetHistoricalData } from 'reducers/environmentMonitor/reducer'
import messages from './translate'

class ListViewHistorical extends Component {
  componentWillUnmount() {
    this.props.resetHistoricalData()
  }

  render() {
    const {
      intl: { formatMessage },
      icon,
      unit,
    } = this.props
    const date = this.props.listHistoryData.get('time')
    const data = this.props.listHistoryData.get('data')
    const isAfterDate = moment(date).isAfter()
      ? messages.tomorrow
      : messages.yesterday
    const dayName = formatMessage(
      moment(date).isSame(moment(), 'day') ? messages.today : isAfterDate,
    )

    return (
      <Paper className="sensor-list history-type">
        <div className="current-time">{`${dayName} - ${moment(date).format(
          'HH:mm',
        )}`}</div>
        {data.map(item => (
          <div
            key={`key_${item.label}`}
            className={`current-type type-${item.label}`}>
            <div className="type-depth">{item.label}</div>
            <div className="type-info">
              <div className="type-data">
                {item.value} <span>{unit}</span>
              </div>
              <div className="type-icon">
                <SvgIcon component={icon}>icon</SvgIcon>
              </div>
            </div>
          </div>
        ))}
      </Paper>
    )
  }
}

export default connect(
  state => ({
    listHistoryData: state.getIn(['environmentMonitor', 'listHistoryData']),
  }),
  {
    resetHistoricalData,
  },
)(injectIntl(ListViewHistorical))
